interface Props {
  shouldWrap?: boolean;
  children: React.ReactNode;
  wrapper: (
    children: React.ReactNode,
    props?: React.PropsWithChildren
  ) => React.ReactNode;
}

const Wrapper: React.FC<Props> = ({
  children,
  shouldWrap,
  wrapper,
  ...props
}) => (shouldWrap ? wrapper(children, props) : children);

export { Wrapper };
